/**
 * Cache-key prefix the consultations list page registers its ListQueryService
 * entries under. The store's mutation effects invalidate this prefix so the
 * list refreshes after a save/update, while embedded cursor lists (which read
 * the NgRx collection) are untouched.
 */
export const CONSULTATION_LIST_QUERY_PREFIX = 'consultation|list|';
